import styled from 'styled-components';

const HeaderLinksContainer = styled.nav`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    ul {
        display: flex;
        li a {
            padding: 40px 10px;
            display: block;
            color: white;
            text-decoration: none;
            font-size: 14px;
            transition: 0.3s;
            position: relative;
            z-index: 2;
            &.active,
            &:hover {
                color: var(--main-color);
                border-bottom: 1px solid var(--main-color);
            }
        }
    }
`;

export default HeaderLinksContainer;
